import { inject } from 'inversify-props';
import IAuthService from 'services/IAuthService';
import { IFormat } from '@models';
import { AxiosPromise } from 'axios';

class FormatService {
    @inject() private authService: IAuthService;

    host: string = `${window.location.protocol}//${window.location.host}`;
    api: string = '/api/format/';


    constructor(api: string = null) {
        if (api) this.api = api
    }

    formatExists(id: string): AxiosPromise<boolean> {
        const endpoint = `${this.host}${this.api}exists/${id}`;
        
        return this.authService.getV2(endpoint);
    }

    saveFormat(format: IFormat) {
        const endpoint = this.host + this.api;

        if (!format.description || format.description.length < 1)
            format.description = format.id;
        if (!format.displayTitle || format.displayTitle.length < 1)
            format.displayTitle = format.id;

        const response = this.authService.post(endpoint, format);

        return response;
    }

    updateFormat(format: IFormat): AxiosPromise<boolean> {
        const endpoint = this.host + this.api;
        return this.authService.put(endpoint, format);
    }

    getFormats(): AxiosPromise<IFormat[]> {
        const endpoint = this.host + this.api;

        return this.authService.get(endpoint);
    }

    getFormat(id: string): AxiosPromise<IFormat> {
        const endpoint = `${this.host}${this.api}${id}`;
        const response = this.authService.getV2(endpoint);
        return response;
    }
}

export default new FormatService();
